<template>
  <appEmailWizard></appEmailWizard>
</template>
<script>
import appEmailWizard from '../../components/emailMarketing/EMWizard.vue'

export default {
  name: 'EmailWizard',
  components: {
    appEmailWizard
  }
}
</script>
